import Button from '@pelckmans/elementis/components/button';
import { useTranslation } from 'react-i18next';

const TRANSLATION_BASE = 'PAGES.RESULTS.MODALS.SCORABLE_ITEMS_FILTER.EMPTY';

interface Props {
  onClearFiltersClick: () => void;
}

export default function Empty({ onClearFiltersClick }: Props) {
  const { t } = useTranslation();

  return (
    <div className="scorable-item-filter-modal__empty">
      <div>
        <p className="title">{t(`${TRANSLATION_BASE}.TITLE`)}</p>
        <p>{t(`${TRANSLATION_BASE}.TEXT`)}</p>
      </div>
      <Button prominence="neutral" size="sm" onClick={onClearFiltersClick}>
        {t(`${TRANSLATION_BASE}.BUTTON`)}
      </Button>
    </div>
  );
}
